import type { Annotation, Communication } from 'fhir/r4';
import React, { useMemo } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import type { CommunicationData } from 'types';

import CommunicationNoteForm from './communicationNoteForm';

type CommunicationNoteProps = {
  communicationPayload: Communication;
  orgId?: string | undefined;
  patientId?: string | undefined;
  refresh: () => Promise<CommunicationData | undefined>;
  subject: string | undefined;
};

const CommunicationNote: React.FC<CommunicationNoteProps> = ({
  communicationPayload,
  orgId,
  patientId,
  refresh,
  subject,
}) => {
  const isUnknownCaller = !orgId;

  const noteList = useMemo(() => {
    if (!communicationPayload.note) return [];

    return communicationPayload.note
      .filter((note) => note.authorString) // Filter notes with an author
      .sort((a, b) => new Date(b.time!).getTime() - new Date(a.time!).getTime()); // Sort in descending order
  }, [communicationPayload.note]);
  //console.log(noteList, communicationPayload);

  const extensionList = useMemo(() => {
    /* if (!communicationPayload.extension?.find(e =>
      e.url === "https://projectwell.io/fhir/zoom-web-hook/extensions/zoom-engagement-note"
    )?.extension) return []; */

    return communicationPayload.extension
      ?.filter(
        (e) =>
          e.url === 'https://projectwell.io/fhir/zoom-web-hook/extensions/zoom-engagement-note' &&
          e.extension,
      )?.[0]
      ?.extension?.filter((note) => note.valueCodeableConcept?.text) // Filter notes with correct data
      ?.map((note) => ({
        text: note.valueCodeableConcept!.text!.split('|')?.[0],
        authorString: note.valueCodeableConcept!.text!.split('|')?.[2]?.split('Author:')?.[1],
        time: note.valueCodeableConcept!.text!.split('|')?.[3]?.split('Last Modifed Time:')?.[1],
      })) // change format from text/code/author/date to text/authorString/time
      ?.sort((a, b) => new Date(b.time!).getTime() - new Date(a.time!).getTime()) as Annotation[]; // Sort in descending order
  }, [communicationPayload.extension]);

  return (
    <>
      <Popup
        trigger={
          <Icon
            name="sticky note"
            color={noteList && noteList?.length > 0 ? 'orange' : 'grey'}
            style={{ cursor: 'pointer' }}
          />
        }
        on="click"
        style={{ zIndex: 999, width: '600px' }}
      >
        <CommunicationNoteForm
          communicationPayload={communicationPayload}
          isUnknownCaller={isUnknownCaller}
          noteList={noteList}
          orgId={orgId}
          patientId={patientId}
          refresh={refresh}
          subject={subject}
          isMutable={true}
        />
      </Popup>
      {extensionList && extensionList?.length > 0 && (
        <Popup
          trigger={<Icon name="sticky note" color={'blue'} style={{ cursor: 'pointer' }} />}
          on="click"
          style={{ zIndex: 999, width: '600px' }}
        >
          <CommunicationNoteForm
            communicationPayload={communicationPayload}
            isUnknownCaller={isUnknownCaller}
            noteList={extensionList}
            orgId={orgId}
            patientId={patientId}
            refresh={refresh}
            subject={subject}
            isMutable={false}
          />
        </Popup>
      )}
    </>
  );
};

export default CommunicationNote;
